import React, { useEffect, useRef } from 'react';

const img1 = "/images/assets/a7fb705126b1b88d2ad66145b717fd05a691ac20.png";
const img2 = "/images/assets/7551b2704d630b00a4eb8d4e03aa28917c8047cc.png";
const img3 = "/images/assets/2eab2674fd62ba4010478e9c9de4d4fbd0d80dca.png";
const img4 = "/images/assets/0287372f2707f312d30276db770c36af4e38d291.png";
const img5 = "/images/assets/baf19281793a9eaf7a191ed1e64c84ed57bc5d62.png";
const img6 = "/images/assets/4d57b25877f106c62b2ea4b5f34163d759467bc6.png";
const img7 = "/images/assets/37cf24932b42dc6235e18c56a1053bc4c0017ec4.png";
const img8 = "/images/assets/1fae9ee1718155feb0ad6698ff94694cc3b368e7.png";
const img9 = "/images/assets/7fc889b2932f55bdebbebd7069c4cee9b3a63965.png";
const imgImage1 = "/images/assets/32f93cfb7d1d8302690353d773463785a811b15f.png";

function Frame53() {
  return (
    <div className="content-stretch flex flex-col gap-2 items-start relative shrink-0 w-full">
      <p className="font-['Roboto:Medium',sans-serif] font-medium leading-tight text-3xl sm:text-4xl md:text-[40px] lg:text-[48px] relative shrink-0 text-black w-full md:w-[561px]" style={{ fontVariationSettings: "'wdth' 100" }}>Popular Categories</p>
    </div>
  );
}

function Frame9() {
  return (
    <div className="content-stretch flex flex-col gap-6 md:gap-8 xl:gap-[48px] h-auto xl:h-[708px] items-start relative shrink-0 w-full xl:w-[600px] 2xl:w-[620px] min-[1600px]:w-[644px]">
      <Frame53 />
      <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-7 md:leading-[24px] relative shrink-0 text-lg md:text-xl xl:text-[24px] text-black w-full xl:w-[588px] 2xl:w-[608px] min-[1600px]:w-[632px]" style={{ fontVariationSettings: "'wdth' 100" }}>
        <span>{`Whatever your requirement — `}</span>
        <span className="text-[#3a599c]" style={{ fontVariationSettings: "'wdth' 100" }}>HyreLancer</span>
        <span>{` has the right expert for you.`}</span>
      </p>
    </div>
  );
}

const categories = [
  { title: "IT & Software Development", image: img1 },
  { title: "Graphic & Web Design", image: img2 },
  { title: "Digital Marketing", image: img3 },
  { title: "Makeup & Beauty Services", image: img4 },
  { title: "Writing & Content Creation", image: img5 },
  { title: "Photography & Video Editing", image: img6 },
  { title: "Fitness & Personal Training", image: img7 },
  { title: "Business Consulting", image: img8 },
  { title: "Event Management", image: img9 }
];

function CategoryCard({ title, image }) {
  return (
    <div className="h-[250px] sm:h-[280px] md:h-[300px] lg:h-[332px] relative rounded-2xl md:rounded-[16px] shrink-0 w-full">
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none rounded-2xl md:rounded-[16px]">
        <img alt="" className="absolute max-w-none object-center md:object-50%-50% object-cover rounded-2xl md:rounded-[16px] size-full" src={image} />
        <div className="absolute bg-[rgba(0,0,0,0.42)] inset-0 rounded-2xl md:rounded-[16px]" />
      </div>
      <div className="flex flex-row items-center overflow-clip rounded-[inherit] size-full">
        <div className="box-border content-stretch flex h-full items-center p-4 sm:p-5 md:p-6 relative w-full">
          <div className="basis-0 content-stretch flex flex-col gap-8 sm:gap-10 md:gap-12 lg:gap-[56px] grow h-full items-start justify-end min-h-px min-w-px relative shrink-0">
            <div className="content-stretch flex flex-col gap-3 md:gap-4 items-start relative shrink-0 w-full">
              <p className="font-['Roboto:SemiBold',sans-serif] font-semibold leading-6 md:leading-[24px] relative shrink-0 text-lg sm:text-xl md:text-[22px] lg:text-[24px] text-white w-full" style={{ fontVariationSettings: "'wdth' 100" }}>{title}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function ScrollingColumn({ items, direction = 'down' }) {
  const scrollRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    const cardHeight = 332;
    const gap = 32;
    const totalHeight = (cardHeight + gap) * items.length;
    let scrollPosition = direction === 'up' ? totalHeight : 0;

    const scroll = () => {
      if (direction === 'down') {
        scrollPosition += 0.5;
        if (scrollPosition >= totalHeight) {
          scrollPosition = 0;
        }
        scrollContainer.style.transform = `translateY(-${scrollPosition}px)`;
      } else {
        scrollPosition -= 0.5;
        if (scrollPosition <= 0) {
          scrollPosition = totalHeight;
        }
        scrollContainer.style.transform = `translateY(-${scrollPosition}px)`;
      }
      
      animationRef.current = requestAnimationFrame(scroll);
    };

    animationRef.current = requestAnimationFrame(scroll);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [items.length, direction]);

  return (
    <div className="relative h-full overflow-hidden">
      <div ref={scrollRef} className="flex flex-col gap-[32px]" style={{ willChange: 'transform' }}>
        {/* First set of items */}
        {items.map((category, index) => (
          <CategoryCard key={`first-${index}`} title={category.title} image={category.image} />
        ))}
        {/* Duplicate set for seamless loop */}
        {items.map((category, index) => (
          <CategoryCard key={`second-${index}`} title={category.title} image={category.image} />
        ))}
      </div>
    </div>
  );
}

function Frame83() {
  return (
    <div className="hidden 2xl:block absolute bottom-0 left-0 right-[69.41%] top-0">
      <ScrollingColumn items={categories.slice(0, 3)} direction="down" />
    </div>
  );
}

function Frame84() {
  return (
    <div className="absolute inset-[0.98%_34.71%]">
      <ScrollingColumn items={categories.slice(3, 6)} direction="up" />
    </div>
  );
}

function Frame85() {
  return (
    <div className="hidden 2xl:block absolute bottom-[1.23%] left-[69.41%] right-0 top-[1.23%]">
      <ScrollingColumn items={categories.slice(6, 9)} direction="down" />
    </div>
  );
}

function Frame88() {
  return (
    <div className="relative xl:absolute box-border content-stretch flex flex-col xl:flex-row gap-6 md:gap-8 xl:gap-1 2xl:gap-8 min-[1600px]:gap-[138px] items-start xl:items-center xl:left-1/2 px-4 md:px-8 xl:px-8 2xl:px-12 min-[1600px]:px-[144px] py-0 xl:top-[-4px] xl:translate-x-[-50%] w-full xl:w-auto overflow-visible h-[calc(100vh-64px)] sm:h-[calc(100vh-80px)] md:h-[calc(100vh-96px)] xl:h-auto">
      <Frame9 />
      {/* Desktop view (2xl+) - side by side with all 3 columns */}
      <div className="hidden 2xl:block h-[calc(100vh-96px)] relative shrink-0 w-[720px] min-[1600px]:w-[801px] overflow-visible" data-name="Component 2">
        {/* Top gradient fade - extended width */}
        <div className="absolute top-0 h-[88px] z-50 pointer-events-none" style={{ left: '-20px', right: '-20px', background: 'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0.987) 8.1%, rgba(255,255,255,0.951) 15.5%, rgba(255,255,255,0.896) 22.5%, rgba(255,255,255,0.825) 29%, rgba(255,255,255,0.741) 35.3%, rgba(255,255,255,0.648) 41.2%, rgba(255,255,255,0.550) 47.1%, rgba(255,255,255,0.450) 52.9%, rgba(255,255,255,0.352) 58.8%, rgba(255,255,255,0.259) 64.7%, rgba(255,255,255,0.175) 71%, rgba(255,255,255,0.104) 77.5%, rgba(255,255,255,0.049) 84.5%, rgba(255,255,255,0.013) 91.9%, rgba(255,255,255,0) 100%)' }} />
        {/* Bottom gradient fade - extended width */}
        <div className="absolute bottom-0 h-[128px] z-50 pointer-events-none" style={{ left: '-20px', right: '-20px', background: 'linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,0.987) 8.1%, rgba(255,255,255,0.951) 15.5%, rgba(255,255,255,0.896) 22.5%, rgba(255,255,255,0.825) 29%, rgba(255,255,255,0.741) 35.3%, rgba(255,255,255,0.648) 41.2%, rgba(255,255,255,0.550) 47.1%, rgba(255,255,255,0.450) 52.9%, rgba(255,255,255,0.352) 58.8%, rgba(255,255,255,0.259) 64.7%, rgba(255,255,255,0.175) 71%, rgba(255,255,255,0.104) 77.5%, rgba(255,255,255,0.049) 84.5%, rgba(255,255,255,0.013) 91.9%, rgba(255,255,255,0) 100%)' }} />
        <Frame83 />
        <Frame84 />
        <Frame85 />
      </div>
      {/* XL view - side by side with only 2 columns (left & center) */}
      <div className="hidden xl:block 2xl:hidden h-[calc(100vh-96px)] relative shrink-0 w-[550px] overflow-visible" data-name="Component 2 XL">
        {/* Top gradient fade - extended width and height */}
        <div className="absolute h-[88px] z-50 pointer-events-none" style={{ top: '-10px', left: '-20px', right: '-20px', background: 'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0.987) 8.1%, rgba(255,255,255,0.951) 15.5%, rgba(255,255,255,0.896) 22.5%, rgba(255,255,255,0.825) 29%, rgba(255,255,255,0.741) 35.3%, rgba(255,255,255,0.648) 41.2%, rgba(255,255,255,0.550) 47.1%, rgba(255,255,255,0.450) 52.9%, rgba(255,255,255,0.352) 58.8%, rgba(255,255,255,0.259) 64.7%, rgba(255,255,255,0.175) 71%, rgba(255,255,255,0.104) 77.5%, rgba(255,255,255,0.049) 84.5%, rgba(255,255,255,0.013) 91.9%, rgba(255,255,255,0) 100%)' }} />
        {/* Bottom gradient fade - extended width and height */}
        <div className="absolute h-[128px] z-50 pointer-events-none" style={{ bottom: '-10px', left: '-20px', right: '-20px', background: 'linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,0.987) 8.1%, rgba(255,255,255,0.951) 15.5%, rgba(255,255,255,0.896) 22.5%, rgba(255,255,255,0.825) 29%, rgba(255,255,255,0.741) 35.3%, rgba(255,255,255,0.648) 41.2%, rgba(255,255,255,0.550) 47.1%, rgba(255,255,255,0.450) 52.9%, rgba(255,255,255,0.352) 58.8%, rgba(255,255,255,0.259) 64.7%, rgba(255,255,255,0.175) 71%, rgba(255,255,255,0.104) 77.5%, rgba(255,255,255,0.049) 84.5%, rgba(255,255,255,0.013) 91.9%, rgba(255,255,255,0) 100%)' }} />
        <div className="absolute bottom-0 left-0 right-1/2 top-0 pr-4">
          <ScrollingColumn items={categories.slice(0, 3)} direction="down" />
        </div>
        <div className="absolute bottom-0 left-1/2 right-0 top-0 pl-4">
          <ScrollingColumn items={categories.slice(3, 6)} direction="up" />
        </div>
      </div>
      {/* Mobile view (below md) - only 2 columns (left & center) */}
      <div className="md:hidden flex-1 min-h-0 relative shrink-0 w-full flex gap-4 overflow-visible" data-name="Component 2 Mobile Small">
        {/* Top gradient fade - extended width and height */}
        <div className="absolute h-[88px] z-50 pointer-events-none" style={{ top: '-10px', left: '-20px', right: '-20px', background: 'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0.987) 8.1%, rgba(255,255,255,0.951) 15.5%, rgba(255,255,255,0.896) 22.5%, rgba(255,255,255,0.825) 29%, rgba(255,255,255,0.741) 35.3%, rgba(255,255,255,0.648) 41.2%, rgba(255,255,255,0.550) 47.1%, rgba(255,255,255,0.450) 52.9%, rgba(255,255,255,0.352) 58.8%, rgba(255,255,255,0.259) 64.7%, rgba(255,255,255,0.175) 71%, rgba(255,255,255,0.104) 77.5%, rgba(255,255,255,0.049) 84.5%, rgba(255,255,255,0.013) 91.9%, rgba(255,255,255,0) 100%)' }} />
        {/* Bottom gradient fade - extended width and height */}
        <div className="absolute h-[128px] z-50 pointer-events-none" style={{ bottom: '-10px', left: '-20px', right: '-20px', background: 'linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,0.987) 8.1%, rgba(255,255,255,0.951) 15.5%, rgba(255,255,255,0.896) 22.5%, rgba(255,255,255,0.825) 29%, rgba(255,255,255,0.741) 35.3%, rgba(255,255,255,0.648) 41.2%, rgba(255,255,255,0.550) 47.1%, rgba(255,255,255,0.450) 52.9%, rgba(255,255,255,0.352) 58.8%, rgba(255,255,255,0.259) 64.7%, rgba(255,255,255,0.175) 71%, rgba(255,255,255,0.104) 77.5%, rgba(255,255,255,0.049) 84.5%, rgba(255,255,255,0.013) 91.9%, rgba(255,255,255,0) 100%)' }} />
        <div className="flex-1 relative">
          <ScrollingColumn items={categories.slice(0, 3)} direction="down" />
        </div>
        <div className="flex-1 relative">
          <ScrollingColumn items={categories.slice(3, 6)} direction="up" />
        </div>
      </div>
      {/* Tablet view (md to xl) - all 3 columns below text */}
      <div className="hidden md:block xl:hidden flex-1 min-h-0 relative shrink-0 w-full overflow-visible" data-name="Component 2 Tablet">
        {/* Top gradient fade - extended width and height */}
        <div className="absolute h-[88px] z-50 pointer-events-none" style={{ top: '-10px', left: '-20px', right: '-20px', background: 'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0.987) 8.1%, rgba(255,255,255,0.951) 15.5%, rgba(255,255,255,0.896) 22.5%, rgba(255,255,255,0.825) 29%, rgba(255,255,255,0.741) 35.3%, rgba(255,255,255,0.648) 41.2%, rgba(255,255,255,0.550) 47.1%, rgba(255,255,255,0.450) 52.9%, rgba(255,255,255,0.352) 58.8%, rgba(255,255,255,0.259) 64.7%, rgba(255,255,255,0.175) 71%, rgba(255,255,255,0.104) 77.5%, rgba(255,255,255,0.049) 84.5%, rgba(255,255,255,0.013) 91.9%, rgba(255,255,255,0) 100%)' }} />
        {/* Bottom gradient fade - extended width and height */}
        <div className="absolute h-[128px] z-50 pointer-events-none" style={{ bottom: '-10px', left: '-20px', right: '-20px', background: 'linear-gradient(to top, rgba(255,255,255,1) 0%, rgba(255,255,255,0.987) 8.1%, rgba(255,255,255,0.951) 15.5%, rgba(255,255,255,0.896) 22.5%, rgba(255,255,255,0.825) 29%, rgba(255,255,255,0.741) 35.3%, rgba(255,255,255,0.648) 41.2%, rgba(255,255,255,0.550) 47.1%, rgba(255,255,255,0.450) 52.9%, rgba(255,255,255,0.352) 58.8%, rgba(255,255,255,0.259) 64.7%, rgba(255,255,255,0.175) 71%, rgba(255,255,255,0.104) 77.5%, rgba(255,255,255,0.049) 84.5%, rgba(255,255,255,0.013) 91.9%, rgba(255,255,255,0) 100%)' }} />
        <div className="flex gap-6 h-full">
          <div className="flex-1 relative">
            <ScrollingColumn items={categories.slice(0, 3)} direction="down" />
          </div>
          <div className="flex-1 relative">
            <ScrollingColumn items={categories.slice(3, 6)} direction="up" />
          </div>
          <div className="flex-1 relative">
            <ScrollingColumn items={categories.slice(6, 9)} direction="down" />
          </div>
        </div>
      </div>
    </div>
  );
}

function Frame79() {
  return (
    <div className="min-h-0 xl:min-h-[800px] xl:h-[808px] overflow-visible relative shrink-0 w-full max-w-[1921px] mx-auto">
      <div className="hidden xl:block absolute h-[656px] left-0 top-[144px] w-[1050px]" data-name="image 1">
        <img alt="" className="absolute inset-0 max-w-none object-50%-50% object-cover opacity-[0.07] pointer-events-none size-full" src={imgImage1} />
      </div>
      <Frame88 />
      <div className="hidden xl:block absolute h-[816px] right-0 top-1/2 translate-y-[-50%] w-[1076px]" />
    </div>
  );
}

export default function PopularCategoriesSection() {
  return (
    <div className="box-border content-stretch flex flex-col gap-[10px] items-start px-0 py-[48px] relative shrink-0 w-full max-w-[1920px] mx-auto overflow-visible">
      <Frame79 />
    </div>
  );
}